import * as React from "react";
import { HashRouter as Router } from "react-router-dom";
import { withRouter, Route } from "react-router";
import { History } from "history";
import { InicioGeneral } from "app/features/inicio/index";
import { setHistory } from "./history";
import { EnInactividad } from "app/features/componentes/inactividad";
import { Session } from "../resources/items/session";
import { history as historia } from "app/main/std";

class AppRouter extends React.PureComponent<{ history?: History }> {

    async componentDidMount(): Promise<void> {
        setHistory(this.props.history!);

        var token = Session.getToken();
        setTimeout(async () => {
            if (token) {
                await EnInactividad(() => {
                    Session.set(null);
                    historia.go("/");
                });
            }
        }, 1000);
    }

    render() {
        return (
            <Route path="/" component={InicioGeneral} />
        )
    }
}

export class App extends React.PureComponent {
    render() {
        return (
            <Router>
                <Route path="/" component={AppRouter} />
            </Router>
        )
    }
}


// WEBPACK FOOTER //
// ./app/main/app.tsx